import WysiwygBlock from '../blocks/WysiwygBlock';
export interface TableFaqItemProps {
  category?: string;
  id: string;
  question: string;
  answer: string;
}
export default function TableFaqItem({ id, question, answer }: TableFaqItemProps) {
  return (
    <div key={id} className="collapse collapse-plus">
      <input type="checkbox" name={`faq-accordion-${id}`} />
      <div className="collapse-title text-xl font-medium">
        <h3 className="text-sm font-bold md:w-5/6">{question}</h3>
      </div>
      <div className="collapse-content text-sm">
        <WysiwygBlock html={answer} styles="md:w-5/6" />
      </div>
    </div>
  );
}
